import { getApiBaseUrl } from '../config/api';

export type DataAccessRequestType = 'EXPORT' | 'DELETION';
export type DataAccessRequestStatus = 'QUEUED' | 'FULFILLED' | 'DENIED';

export interface DataAccessRequest {
  id: string;
  userId: string;
  requestType: DataAccessRequestType;
  status: DataAccessRequestStatus;
  mfaVerifiedAt: string | null;
  createdAt: string;
}

function authHeaders(): HeadersInit {
  const token = localStorage.getItem('authToken');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

export const dataAccessRequestService = {
  async listMine(): Promise<DataAccessRequest[]> {
    const baseUrl = await getApiBaseUrl();
    const res = await fetch(`${baseUrl}/data-access-requests/me`, { headers: authHeaders() });
    if (!res.ok) throw new Error('Failed to load data access requests');
    const body = await res.json();
    return body.requests;
  },

  async submit(requestType: DataAccessRequestType): Promise<DataAccessRequest> {
    const baseUrl = await getApiBaseUrl();
    const res = await fetch(`${baseUrl}/data-access-requests`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify({ requestType }),
    });
    const body = await res.json();
    if (!res.ok) {
      const message = body.message ?? body.error ?? 'Failed to submit request';
      throw new Error(message);
    }
    return body.request;
  },
};
